import { Component } from '@angular/core';
import { CreatePasswordMode, CreatePasswordFormComponent } from '../../components/create-password-form/create-password-form.component';

@Component({
    selector: 'app-confirm-new-user',
    templateUrl: './confirm-new-user.component.html',
    styleUrls: ['./confirm-new-user.component.scss'],
    imports: [CreatePasswordFormComponent]
})
export class ConfirmNewUserComponent {
  createPasswordModes = CreatePasswordMode;

  constructor() {}
}
